import { useQuery } from '@tanstack/react-query';
import {
  fetchLegacySchemaInventory,
  fetchLegacyTable,
  type LegacySchemaInventory,
  type LegacyTableBrowseResult,
} from '../../services/legacyUserManager';

export const legacySchemaInventoryQueryKey = [
  'admin',
  'legacy-schema',
  'inventory',
] as const;

export function useLegacySchemaInventoryQuery() {
  return useQuery<LegacySchemaInventory>({
    queryKey: legacySchemaInventoryQueryKey,
    queryFn: fetchLegacySchemaInventory,
  });
}

export const legacyTableQueryKey = (
  tableName: string,
  page: number,
  pageSize: number
) => ['admin', 'legacy-schema', 'table', tableName, page, pageSize] as const;

export function useLegacyTableQuery(
  tableName: string | null,
  page: number,
  pageSize: number
) {
  return useQuery<LegacyTableBrowseResult>({
    queryKey: legacyTableQueryKey(tableName ?? '', page, pageSize),
    queryFn: () => fetchLegacyTable(tableName as string, page, pageSize),
    enabled: Boolean(tableName),
  });
}
